import React from 'react';
import CurrentMonth from './CurrentMonth';
import Yearly from './Yearly';

export default function Clients({ period }) {
  return (
    period === 'current_month' ? <CurrentMonth /> : <Yearly />
  );
}
